const accordionDataFields = `
    accordion{
        accordionPane{
            header
            richText
        }
    }
    accordionStyle{
        activeHeader{
            color
            backgroundColor
        }
        activeBody{
            color
            backgroundColor
        }
        inactiveHeader{
            color
            backgroundColor
        }
    }
`

const jumbotronDataFields = `
    text{
        title
        subtitle
    }
    media{
        media{
            sizes{
                large{
                    url
                }
            }
        }
        mobileMedia{
            id
            sizes{
                large{
                    url
                }
            }
        }
    }
    styling{
        backgroundColor
        title{
            color
        }
        subTitle{
            color
        }
    }
`

const richTextDataFields = `
    richText
`

const quotesDataFields = `
    richText
    link
    date
    color{
        backgroundColor
        color
    }
    author
    profileAuthor{
        relationTo
        value{
            ... on Legacyprofile{
                id
                slug
                fullName
                region
                legacyProfileImage: profileImage
            }
            ... on Publicprofile{
                id
                slug
                profileEntity{
                    fullName
                    region
                }
                publicProfileImage: profileImage{
                    title
                    sizes{
                        large{
                            url
                        }
                    }
                }
            }
        }
    }
    fullName
    authorPicture{
        id
        title
        mimeType
        sizes{
            large{
                url
            }
        }
    }
`

const mediaBlockDataFields = `
    media{
        url
        mimeType
        title
        mux{
            assetId
            playbackId
            status
        }
        sizes{
            webp{
                url
            }
            thumbnail{
                url
            }
        }
        coverImage{
            sizes{
                medium{
                    url
                }
            }
        }
    }
    caption
    altText
    link
`

const elementDataFields = `
    ... on MediaBlock{
        id
        blockType
        blockName
        ${mediaBlockDataFields}
    }
    ... on RichText{
        id
        blockType
        blockName
        ${richTextDataFields}
    }
`

const profileRelationAndValueFields = `
    relationTo
    value{
        ... on Legacyprofile{
            id
            slug
            fullName
            region
            description
            legacyProfileImage: profileImage
            professions{
                profession
            }
        }
        ... on Publicprofile{
            id
            slug
            _status
            overview
            profileEntity{
                status
                fullName
                region
            }
            meta{
                description
            }
            publicProfileImage: profileImage{
                sizes{
                    webp{
                        url
                    }
                    medium{
                        url
                    }
                    thumbnail{
                        url
                    }
                }
            }
        }
    }
`

const profileListDataFields = `
    profileList{
        keyProfile
        profile{
            ${profileRelationAndValueFields}
        }
    }
    listFormat
`

const embeddedVideoDataFields = `
    source
    videoId
    caption
`

const pdfDownloadDataFields = `
    audienceId
`

const regularProfileListDataFields = `
    regularHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`

const compactProfileListDataFields = `
    compactHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`

const textSectionDataFields = `
    content{
        richText
    }
`

const keyProfileListDataFields = `
    keyHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`
export const postDataFields = `
    id
    block{
        ... on Jumbotron{
            id
            blockType
            blockName
            ${jumbotronDataFields}
        }
        ... on MediaBlock{
            id
            blockType
            blockName
            ${mediaBlockDataFields}
        }
        ... on EmbeddedVideo{
            id
            blockType
            blockName
            ${embeddedVideoDataFields}
        }
        ... on Accordion{
            id
            blockType
            blockName
            ${accordionDataFields}
        }
        ... on Quotes{
            id
            blockType
            blockName
            ${quotesDataFields}
        }
        ... on Carousel{
            id
            blockType
            blockName
            element{
                ${elementDataFields}
            }
            autoSliding
            showNavigation
            indicators
        }
        ... on pdfDownload{
            id
            blockType
            blockName
            ${pdfDownloadDataFields}
        }
        ... on RegularProfileList{
            id
            blockType
            blockName
            ${regularProfileListDataFields}
        }
        ... on CompactProfileList{
            id
            blockType
            blockName
            ${compactProfileListDataFields}
        }
        ... on KeyProfileList{
            id
            blockType
            blockName
            ${keyProfileListDataFields}
        }
        ... on TextSection{
            id
            blockType
            blockName
            ${textSectionDataFields}
        }
        ... on RichText{
            id
            blockType
            blockName
            ${richTextDataFields}
        }
        ... on ProfileList{
            id
            blockType
            blockName
            ${profileListDataFields}
        }
    }
    title
    slug
    publishDate
    firstPublishedAt
    coverimage{
        sizes{
            medium{
                url
            }
        }
    }
`


